import { useCallback, useEffect, useRef } from 'react';
import { FieldErrors } from 'react-hook-form';
import { IFormState } from '../types/calculator';

export const useDelayedSuccessHandler = (
  handleSuccess: (calcValues: IFormState, errors: FieldErrors<IFormState>) => void,
) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const delayedSuccessHandler = useCallback(
    (calcValues: IFormState, errors: FieldErrors<IFormState>) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        handleSuccess(calcValues, errors);
      }, 50);
    },
    [handleSuccess],
  );

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return delayedSuccessHandler;
};
